/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const Language = {
	PL: 'PL',
	EN: 'EN',
	SK: 'SK',
	CZ: 'CZ',
	CS: 'CS',
	DE: 'DE',
	ES: 'ES',
	CA: 'CA',
	TH: 'TH',
	RU: 'RU',
	UK: 'UK',
	PT: 'PT',
	SI: 'SI',
	HR: 'HR',
	SL: 'SL',
	HU: 'HU',
	IT: 'IT',
	AT: 'AT',
	RO: 'RO',
} as const;
export type Language = (typeof Language)[keyof typeof Language];

export function instanceOfLanguage(value: any): boolean {
	for (const key in Language) {
		if (Object.prototype.hasOwnProperty.call(Language, key)) {
			if (Language[key as keyof typeof Language] === value) {
				return true;
			}
		}
	}
	return false;
}

export function LanguageFromJSON(json: any): Language {
	return LanguageFromJSONTyped(json, false);
}

export function LanguageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Language {
	return json as Language;
}

export function LanguageToJSON(value?: Language | null): any {
	return value as any;
}

export function LanguageToJSONTyped(value: any, ignoreDiscriminator: boolean): Language {
	return value as Language;
}
